import { calculateRegistrationFee } from "@dmf/calculator-library"
import moment from "moment"
import { getCalculatedEquipmentTax, shouldCalculateEquipmentTax } from "./equipmentTax"
import { EquipmentCatalog } from "../../../../../types/newPriceTypes"
import { Vehicle } from "../../../../../types/appTypes"

export function calculateEquipmentPrice(equipment: EquipmentCatalog[]) {
  let sum = 0;

  for (const eq of equipment) {
    if (!(eq.mounted || eq.isForceMounted)) continue;
    if (eq.includedInNewPrice) continue;
    if (eq.isIncludedInMountedPackage) continue;
    sum += eq.amount ?? 0;
  }

  return sum;
}

export function calculateNewPriceFromTaxableValue(selectedNewPrice: number, equipment: EquipmentCatalog[], vehicle?: Vehicle | null) {
  if (!shouldCalculateEquipmentTax(vehicle)) {
    return null
  }
  const firstRegDate = moment(vehicle?.firstRegDate);
  if (firstRegDate.year() < 2021) {
    return null;
  }

  const equipmentSum = equipment
    ?.filter(item => item.mounted && !item.includedInNewPrice && !item.isIncludedInMountedPackage)
    .reduce((acc, curr) => {
      const withtax = curr.isWithTax;
      let priceWithoutTax = curr.amount;
      if (withtax) {
        priceWithoutTax = getCalculatedEquipmentTax(vehicle, curr.amount ?? 0, false, selectedNewPrice)
      }
      return acc + (priceWithoutTax ?? 0)
    }, 0)

  const result = calculateRegistrationFee({
    vehicleType: mapVehicleType(vehicle.typeId ?? null),
    batteryCapacity: vehicle.batteryCapacity ?? 0,
    electricConsumption: vehicle.electricConsumption ?? 0,
    electricRange: vehicle.electricRange ?? 0,
    // @ts-expect-error Type 'string' is not assignable to type 'ObjectValues<{ readonly WLTP: "WLTP"; readonly NEDC: "NEDC"; readonly NEDC2: "NEDC2"; }>'
    emissionUnit: vehicle.emissionUnit ?? "WLTP",
    emissionValue: vehicle.emissionAmount ?? 0,
    isNew: true,
    isHighWeight: vehicle.isHighWeight ?? false,
    newPrice: null,
    tradePrice: null,
    taxableValue: selectedNewPrice + equipmentSum,
    versionYear: firstRegDate.year() as 2025
  })

  return {
    equipmentSum,
    newPrice: result?.config?.newPrice,
    taxableValue: result?.config?.taxableValueBeforeDeduction,
    registrationFee: result?.result?.taxAfterAllDeductions
  }
}

function mapVehicleType(typeId: number | null) {
  if (typeId === 2) return "VAN"
  return "PRIVATE_VEHICLE";
}
